import { render, staticRenderFns } from "./ChatModal.vue?vue&type=template&id=3845af7e&scoped=true&"
import script from "./ChatModal.vue?vue&type=script&lang=js&"
export * from "./ChatModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatModal.vue?vue&type=style&index=0&id=3845af7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845af7e",
  null
  
)

export default component.exports